<template>
  <div id="decoration-hidden-player">
    <div id="decorations-player"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "DecorationHiddenPlayer",

  methods: {
    ...mapActions("threekit", ["initThreekitColors", "setLoadingState"]),
    ...mapActions("showroom", ["getDecorationsForSelectedCatalogLayouts", "set2dPlayerReady"]),
    ...mapActions("project", [
      "init2DDecorationsPlayer",
      "updateDecorationsForProjectProductsLayouts",
    ]),
  },

  computed: {
    ...mapState("project", ["locationDecorations"]),
    ...mapState("showroom", ["mascot", "submascot"]),
    ...mapState("threekit", ["spiritwearThumbnail"]),
    ...mapGetters("project", ["isShowroom", "isSnapsheet"]),
  },

  async mounted() {
    //Call for the 3d player
    if (!this.locationDecorations.length) {
      this.$nextTick(async () => {
        setTimeout(async () => {
          try {
            await this.setLoadingState({
              loadingState: true,
              message: "Generating 2D Decorations",
            });
            await this.init2DDecorationsPlayer();
            if (this.isShowroom) {
              this.set2dPlayerReady()
              await this.getDecorationsForSelectedCatalogLayouts();
            } else {
              await this.updateDecorationsForProjectProductsLayouts();
            }
          } catch (error) {
            console.log(error);
            await this.setLoadingState({ loadingState: false, message: null });
          } finally {
            await this.setLoadingState({ loadingState: false, message: null });
          }
        }, 1500);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
#decoration-hidden-player {
  visibility: hidden;
  position: absolute;
  right: 0;
  top: 0;
  width: 500px;
  height: 500px;
  background: white;
  border: 1px solid;
}
</style>
